import { render, staticRenderFns } from "./simTitle.vue?vue&type=template&id=8fa44fac&scoped=true&"
import script from "./simTitle.vue?vue&type=script&lang=js&"
export * from "./simTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa44fac",
  null
  
)

export default component.exports